import React, { type ReactNode } from 'react';
import { Paper, Typography, Box, Tooltip } from '@mui/material';
import { SEARCE_COLORS } from '../../theme';
import { metricSummaryTooltipProps } from '../../constants/metricTooltips';

interface MetricCardProps {
  title: string;
  value: number;
  color: string;
  tooltip?: ReactNode;
}

export const MetricCard: React.FC<MetricCardProps> = ({ title, value, color, tooltip }) => {
  const paper = (
    <Paper
      elevation={0}
      sx={{
        p: 3,
        height: '100%',
        border: `1px solid ${SEARCE_COLORS.border}`,
        borderRadius: 2,
        borderLeft: `4px solid ${color}`,
      }}
    >
      <Typography
        variant="body2"
        sx={{
          fontWeight: 500,
          color: SEARCE_COLORS.textSecondary,
          mb: 1.5,
          fontSize: '0.875rem',
          lineHeight: 1.4,
        }}
      >
        {title}
      </Typography>
      <Typography
        variant="h3"
        sx={{
          fontWeight: 800,
          color: SEARCE_COLORS.textPrimary,
          fontSize: '2.25rem',
          lineHeight: 1.2,
        }}
      >
        {value}
      </Typography>
    </Paper>
  );

  if (tooltip) {
    return (
      <Tooltip title={tooltip} {...metricSummaryTooltipProps}>
        <Box sx={{ width: '100%', display: 'block' }}>{paper}</Box>
      </Tooltip>
    );
  }

  return paper;
};
